import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeLayers,
  FontAwesomeLayersText,
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

import {
  faHome as freeFasFaHome,
  faSwatchbook as freeFasFaSwatchbook,
  faHeart as freeFasFaHeart,
  faIdCardAlt as freeFasFaIdCardAlt,
  faPaintBrush as freeFasFaPaintBrush,
  faHdd as freeFasFaHdd,
  faPaperPlane as freeFasFaPaperPlane,
  faTrash as freeFasFaTrash,
  faClone as freeFasFaClone,
  faIdCard as freeFasFaIdCard,
  faPen as freeFasFaPen,
  faSyncAlt as freeFasFaSyncAlt,
  faHistory as freeFasFaHistory,
  faWindowClose as freeFasFaWindowClose,
  faCommentAlt as freeFasFaCommentAlt,
  faCopy as freeFasFaCopy,
  faPlusSquare as freeFasFaPlusSquare,
  faAddressBook as freeFasFaAddressBook,
  faTrophy as freeFasFaTrophy,
  faCalendarPlus as freeFasFaCalendarPlus,
  faChartLine as freeFasFaChartLine,
  faCode as freeFasFaCode,
  faCog as freeFasFaCog,
  faUserCheck as freeFasFaUserCheck,
  faInfoCircle as freeFasFaInfoCircle,
  faPhoneVolume as freeFasFaPhoneVolume,
  faStar as freeFasFaStar,
  faQrcode as freeFasFaQrcode,
  faUpload as freeFasFaUpload,
  faShareAlt as freeFasFaShareAlt,
  faExternalLinkAlt as freeFasFaExternalLinkAlt,
  faFileImage as freeFasFaFileImage,
  faInbox as freeFasFaInbox,
  faImage as freeFasFaImage,
  faCrop as freeFasFaCrop,
  faEdit as freeFasFaEdit,
  faSearchPlus as freeFasFaSearchPlus,
  faSearchMinus as freeFasFaSearchMinus,
  faSave as freeFasFaSave,
  faArrowLeft as freeFasFaArrowLeft,
  faArrowUp as freeFasFaArrowUp,
  faArrowDown as freeFasFaArrowDown,
  faArrowRight as freeFasFaArrowRight,
  faTimesCircle as freeFasFaTimesCircle,
  faCircleNotch as freeFasFaCircleNotch,
  faUndo as freeFasFaUndo,
  faRedo as freeFasFaRedo,
  faFileAlt as freeFasFaFileAlt,
  faEye as freeFasFaEye,
  faEyeSlash as freeFasFaEyeSlash,
  faGlobeAmericas as freeFasFaGlobeAmericas,
  faSignature as freeFasFaSignature,
  faCreditCard as freeFasFaCreditCard,
  faSearch as freeFasFaSearch,
  faLink as freeFasFaLink,
  faTimes as freeFasFaTimes,
  faSpinner as freeFasFaSpinner,
  faEllipsisH as freeFasFaEllipsisH,
  faCamera as freeFasFaCamera,
  faBars as freeFasFaBars,
  faMap as freeFasFaMap,
  faDatabase as freeFasFaDatabase,
  faEnvelope as freeFasFaEnvelope,
  faPhone as freeFasFaPhone,
  faMobileAlt as freeFasFaMobileAlt,
  faComment as freeFasFaComment,
  faGlobe as freeFasFaGlobe,
  faCheck as freeFasFaCheck,
  faUserTie as freeFasFaUserTie,
  faCheckCircle as freeFasFaCheckCircle
} from '@fortawesome/free-solid-svg-icons'

import {
  faApple as freeFabFaApple,
  faGoogle as freeFabFaGoogle,
  faGithub as freeFabFaGithub,
  faTiktok as freeFabFaTiktok,
  faSpotify as freeFabFaSpotify,
  faSnapchat as freeFabFaSnapchat,
  faFacebookSquare as freeFabFaFacebookSquare,
  faPinterest as freeFabFaPinterest,
  faReddit as freeFabFaReddit,
  faLine as freeFabFaLine,
  faTelegram as freeFabFaTelegram,
  faFacebookF as freeFabFaFacebookF,
  faTwitter as freeFabFaTwitter,
  faXTwitter as freeFabFaXTwitter,
  faSkype as freeFabFaSkype,
  faAlgolia as freeFabFaAlgolia,
  faLinkedin as freeFabFaLinkedin,
  faWeixin as freeFabFaWeixin,
  faStripe as freeFabFaStripe,
  faWhatsapp as freeFabFaWhatsapp,
  faVimeo as freeFabFaVimeo,
  faYoutube as freeFabFaYoutube,
  faInstagram as freeFabFaInstagram,
  faFacebookMessenger as freeFabFaFacebookMessenger,
  faBehance as freeFabFaBehance
} from '@fortawesome/free-brands-svg-icons'

library.add(
  freeFasFaHome,
  freeFasFaSwatchbook,
  freeFasFaHeart,
  freeFasFaIdCardAlt,
  freeFasFaPaintBrush,
  freeFasFaHdd,
  freeFasFaPaperPlane,
  freeFasFaTrash,
  freeFasFaClone,
  freeFasFaIdCard,
  freeFasFaPen,
  freeFasFaSyncAlt,
  freeFasFaHistory,
  freeFasFaWindowClose,
  freeFasFaCommentAlt,
  freeFasFaCopy,
  freeFasFaPlusSquare,
  freeFasFaAddressBook,
  freeFasFaTrophy,
  freeFasFaCalendarPlus,
  freeFasFaChartLine,
  freeFasFaCode,
  freeFasFaCog,
  freeFasFaUserCheck,
  freeFasFaInfoCircle,
  freeFasFaPhoneVolume,
  freeFasFaStar,
  freeFasFaQrcode,
  freeFasFaUpload,
  freeFasFaShareAlt,
  freeFasFaExternalLinkAlt,
  freeFasFaFileImage,
  freeFasFaInbox,
  freeFasFaImage,
  freeFasFaCrop,
  freeFasFaEdit,
  freeFasFaSearchPlus,
  freeFasFaSearchMinus,
  freeFasFaSave,
  freeFasFaArrowLeft,
  freeFasFaArrowUp,
  freeFasFaArrowDown,
  freeFasFaArrowRight,
  freeFasFaTimesCircle,
  freeFasFaCircleNotch,
  freeFasFaUndo,
  freeFasFaRedo,
  freeFasFaFileAlt,
  freeFasFaEye,
  freeFasFaEyeSlash,
  freeFasFaGlobeAmericas,
  freeFasFaSignature,
  freeFasFaCreditCard,
  freeFasFaSearch,
  freeFasFaLink,
  freeFasFaTimes,
  freeFasFaSpinner,
  freeFasFaEllipsisH,
  freeFasFaCamera,
  freeFasFaBars,
  freeFasFaMap,
  freeFasFaDatabase,
  freeFasFaEnvelope,
  freeFasFaPhone,
  freeFasFaMobileAlt,
  freeFasFaComment,
  freeFasFaGlobe,
  freeFasFaCheck,
  freeFasFaUserTie,
  freeFasFaCheckCircle,
  freeFabFaApple,
  freeFabFaGoogle,
  freeFabFaGithub,
  freeFabFaTiktok,
  freeFabFaSpotify,
  freeFabFaSnapchat,
  freeFabFaFacebookSquare,
  freeFabFaPinterest,
  freeFabFaReddit,
  freeFabFaLine,
  freeFabFaTelegram,
  freeFabFaFacebookF,
  freeFabFaTwitter,
  freeFabFaXTwitter,
  freeFabFaSkype,
  freeFabFaAlgolia,
  freeFabFaLinkedin,
  freeFabFaWeixin,
  freeFabFaStripe,
  freeFabFaWhatsapp,
  freeFabFaVimeo,
  freeFabFaYoutube,
  freeFabFaInstagram,
  freeFabFaFacebookMessenger,
  freeFabFaBehance
)

config.autoAddCss = false

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.component('FontAwesomeLayers', FontAwesomeLayers)
Vue.component('FontAwesomeLayersText', FontAwesomeLayersText)
